import { createStyles } from '@material-ui/styles'
import { ThemeType } from 'theme'

export const AppStyles = (_theme: ThemeType) =>
  createStyles({
    '@global': {
      html: {
        '@media (min-width: 768px)': {
          fontSize: '100%',
        },
        '& body': {
          fontFamily: 'Chivo',
        },
      },
    },
  })
